/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path fill="currentcolor" d="M20 20V7h-2v13h-2v-8h-2v8h-2V4h-2v16H8v-6H6v6H4V2H2v20h20v-2z" />
  </Icon>
);
export { SvgChartBar as ChartBar };
